/**
 * Track Product Data
 * 
 * @param {*} product 
 * @param {*} list 
 * @param {*} quantity 
 * @param {*} index 
 */
function trackProductData( product, list, quantity, index ) {
	
	const trackedProduct = {
		id: product.id,
		name: product.name,
		list,
		brand: product.brand?.name,
		category: product.category,
		variant: product.variants[0].option,
		price: product.variants[0].priceRec,
		quantity,
		coupon: product.coupon,
		position: index,
		currency: "USD"
	};

	surf( 'addProduct:digital', trackedProduct );
}


/**
 * Track Cart item data (used for removing existing cart item, initiate checkout).
 * 
 * @param {*} cartItem 
 * @param {*} quantity 
 * @param {*} index 
 */
function trackCartItemData(cartItem, quantity, index) {

	const trackedItem = {
		id: cartItem.product.id,
		name: cartItem.product.name,
		...( cartItem.product.brand && { brand: cartItem.product.brand?.name }),
		category: cartItem.product.category,
		variant: cartItem.option,
		price: cartItem.product.variants[0],
		quantity,
		position: index,
		currency: "USD",
	}

	surf( 'addProduct:digital', trackedItem );
}

/**
 * Track Product(s) impression (view)
 * 
 * @param {*} products 
 * @param {*} list 
 */
export function surfsideTrackImpression( products, list ) {
	if ( typeof surf === 'undefined' ) {
		return;
	}
	products.forEach((product, index) => {
		trackProductData(product, list, 1, index);
	});
	
	surf( 'setCommerceAction:digital', 'detail' );
}

/**
 * Track viewing a promotion
 * 
 * @param {*} id 
 * @param {*} name 
 */
export function surfsideTrackPromoView( special ) {
	if ( typeof surf === 'undefined' ) {
		return;
	}
	surf('addImpression:digital', {
		id: special.id,
		name: special.name,
	});

	surf( 'setCommerceAction:digital', 'view' );
}

/**
 * Track clicking on a promotion
 * 
 * @param {*} id 
 * @param {*} name 
 */
export function surfsideTrackPromoSelect( special ) {
	if ( typeof surf === 'undefined' ) {
		return;
	}
	surf('addImpression:digital', {
		id: special.id,
		name: special.name,
	});

	surf( 'setCommerceAction:digital', 'promo_click' );
}

/**
 * Track viewing Cart
 * 
 * @param {*} id 
 * @param {*} name 
 */
export function surfsideTrackCartView( items = null, pricingType ) {
	if ( typeof surf === 'undefined' ) {
		return;
	}
	
	if ( items ) {
		items.forEach((item, index) => {
			const variant = item.product.variants.find(
				(variant) => variant.option === item.option
			);
			surf( 'addProduct:digital', {
				id: item.product.id,
				name: item.product.name,
				...( item.product.brand && { brand: item.product.brand?.name }),
				category: item.product.category,
				variant: item.option,
				price: pricingType == 'MEDICAL' ? variant.priceMed : variant.priceRec,
				quantity: item.quantity,
				currency: "USD",
			});
		});
	}

	surf('setCommerceAction:digital',
		'cart' // View Cart Action
	);
}


/**
 * Tracks adding an item to cart
 * @param {*} cartItem 
 * @param {*} quantity 
 * @param {*} index 
 */
export function surfsideTrackAddToCart( cartItem, quantity, index ) {
	trackProductData(cartItem, null, quantity, index );
	surf( 'setCommerceAction:digital', 'add' );
}

export function surfsideTrackRemoveFromCart( cartItem, index ) {
	if ( typeof surf === 'undefined' ) {
		return;
	}

	trackCartItemData( cartItem, cartItem.quantity, index );
	surf( 'setCommerceAction:digital', 'remove' );
}

/**
 * Track begin checkout
 * @param {*} trackedItems 
 * @param {*} retailerName 
 */
export function surfsideTrackBeginCheckout( trackedItems, retailerName ) {
	trackedItems.items.forEach((item, index) => {
		surf( 'addProduct:digital', {
			id: item.item_id,
			name: item.item_name,
			brand: item.item_brand,
			category: item.item_category,
			price: item.price,
			quantity: item.quantity,
			coupon: item.coupon,
			position: item.index,
			currency: "USD",
		});
	});
	
	surf('addTransaction:digital', {
		affiliation: retailerName,
		revenue: trackedItems.value, // Transaction Revenue
		tax: trackedItems.tax, // Transaction Tax
		shipping: 0, // Transaction Shipping
		coupon: trackedItems.coupon, // Transaction Coupon
		currency: 'USD', // Transaction Currency
	});

	surf( 'setCommerceAction:digital', 'checkout' );
}

export function surfsideTrackPurchase(purchase) {
	// The transaction data for the purchase.
	surf('addTransaction:digital', {
		id: purchase.transaction_id, // Transaction ID
		revenue: purchase.value, // Transaction Revenue
		tax: purchase.tax, // Transaction Tax
		shipping: 0, // Transaction Shipping
		coupon: purchase.coupon, // Transaction Coupon
		currency: "USD", // Transaction Currency
	});

	if (purchase.items) {
		// The product/s being purchased.
		purchase.items.forEach((item) => {
			surf('addProduct:digital', {
				id: item.item_id,
				name: item.item_name, 
				brand: item.item_brand,
				category: item.item_category, 
				price: item.price,
				quantity: item.quantity, 
				coupon: item.coupon,
				position: item.index, 
				currency: "USD",
			});
		});
	}

	surf( 'setCommerceAction:digital', 'purchase' );
}

export function surfsideSetLocation(locationData = {}) {
	
	if (typeof surf === 'undefined') {
		return;
	}
  
	// Create a new object with only the properties we're interested in
	const currentLocation = {
		id: locationData.id,
		latitude: locationData.latitude,
		longitude: locationData.longitude,
		country_code: locationData.country_code,
		zip: locationData.zip,
		state_label: locationData.state_label,
		state: locationData.state,
		city: locationData.city,
		street: locationData.street,
		name: locationData.name,
		parent: locationData.parent,
		type: locationData.type,
		category: locationData.category
	};
  
	// Remove undefined properties
	Object.keys(currentLocation).forEach(key => currentLocation[key] === undefined && delete currentLocation[key]);
	
	surf('setLocation', currentLocation);

}